module.exports = __webpack_public_path__ + "static/img/3i 智能净地站 F1.06a9374a.png";